import React, { useState, useEffect, useRef } from "react";
import "./Carousel.css"; // Assuming you have a CSS file for styling

const Carousel = ({ images, captions, interval = 3000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const timeoutRef = useRef(null);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  const nextSlide = React.useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  }, [images.length]);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(() => {
      nextSlide();
    }, interval);

    return () => {
      resetTimeout();
    };
  }, [currentIndex, interval, nextSlide]); // add nextSlide here

  const handleTouchStart = (e) => {
    touchStartX.current = e.changedTouches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    touchEndX.current = e.changedTouches[0].clientX;
    if (touchStartX.current - touchEndX.current > 50) {
      nextSlide();
    }
    if (touchEndX.current - touchStartX.current > 50) {
      prevSlide();
    }
  };

  return (
    <div
      className="carousel"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div className="carousel-overlay">
        <p className="overlay-subtitle">{captions[currentIndex].subtitle}</p>
      </div>
      <div
        className="carousel-inner"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {images.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Slide ${index}`}
            className="carousel-image"
          />
        ))}
      </div>
      <button className="carousel-btn prev" onClick={prevSlide}>
        &lt;
      </button>
      <button className="carousel-btn next" onClick={nextSlide}>
        &gt;
      </button>
    </div>
  );
};

export default Carousel;
